import { MouseEvent } from 'react';
import { useTheme } from '@emotion/react';
import Checked from '@engineering/icons/checked';
import { Subtitle, Button, Ui } from '@silvertours/front-shared';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import AccountIllustration from './account_illustration.png';
import {
  BenefitsWrapper,
  BenefitText,
  BenefitWrapper,
  ImageWrapper,
  JoinButton,
  LinkWrapper,
  MembershipWrapper,
} from './MembershipPopover.styles';
import { gtm } from '../../analytics';

const BenefitItem = ({ benefit }: { benefit: string }) => {
  const theme = useTheme();
  return benefit && benefit !== '' && benefit !== 'null' ? (
    <BenefitWrapper>
      <Checked width="24px" fill={theme.colors.brand.green120} />
      <BenefitText key={benefit} inline>
        {benefit}
      </BenefitText>
    </BenefitWrapper>
  ) : null;
};

type MembershipPopoverProps = {
  handleLoginClick: (event: MouseEvent) => void;
  handleSignUpClick: () => void;
};

const MembershipPopover = ({
  handleLoginClick,
  handleSignUpClick,
}: MembershipPopoverProps) => {
  const t = useTranslations('features.navigationLegacy.login');
  const benefitKeys = [
    'membership.benefits.membershipBenefit1',
    'membership.benefits.membershipBenefit2',
    'membership.benefits.membershipBenefit3',
  ] as const;

  const handleTrackedSignupClick = () => {
    gtm.trackNewUser({ isLoggedIn: false });
    handleSignUpClick();
  };

  return (
    <MembershipWrapper>
      <Subtitle as="p">{t('membership.title')}</Subtitle>
      <ImageWrapper>
        <Image src={AccountIllustration} alt="" />
      </ImageWrapper>
      <Button onClick={handleLoginClick} data-testid="accountFlyoutButtonLogin">
        {t('membership.loginButton')}
      </Button>
      <JoinButton
        onClick={handleTrackedSignupClick}
        variant="secondary"
        data-testid="accountFlyoutButtonSignup"
      >
        {t('membership.signupButton')}
      </JoinButton>
      <Subtitle>{t('membership.benefitsTitle')}</Subtitle>
      <BenefitsWrapper>
        {benefitKeys.map(key => (
          <BenefitItem benefit={t(key)} key={t(key)} />
        ))}
      </BenefitsWrapper>
      <LinkWrapper>
        <Ui.TextLink
          text={t('membership.moreInfoLink.text')}
          href={t('membership.moreInfoLink.href')}
        />
      </LinkWrapper>
    </MembershipWrapper>
  );
};

export { MembershipPopover };
